import React from 'react';
import { TableUser, TableColumn, TabId } from '../types';
import { TableContainer } from '../../../Components/Table/TableContainer';

interface UsersContentProps {
  activeTab: TabId;
  columns: TableColumn[];
  data: TableUser[];
  onRowSelect: (selectedRows: TableUser[]) => void;
  totalPages: number;
  currentPage: number;
  onPageChange: (page: number) => void;
  onDelete: (id: number) => void;
}

export const UsersContent: React.FC<UsersContentProps> = ({
  activeTab,
  columns,
  data,
  onRowSelect,
  totalPages,
  currentPage,
  onPageChange,
  onDelete,
}) => {
  return (
    <div className="content content-type">
      <h3>
        {activeTab === 'agency_directors'
          ? "Agency Director's List"
          : "Agency Marketing department's List"}
      </h3>
      <TableContainer
        columns={columns}
        data={data}
        onRowSelect={onRowSelect}
        totalPages={totalPages}
        currentPage={currentPage}
        onPageChange={onPageChange}
        onDelete={onDelete}
        emptyMessage="No users found"
      />
    </div>
  );
};
